export const apiUrl = process.env.REACT_APP_API_URL
export const appName = String(process.env.REACT_APP_APP_NAME)